<template>
  <v-dialog v-model="dialogOpen" max-width="700" scrollable>
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon left color="primary">mdi-store</v-icon>
        Widget Library
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4" style="max-height: 60vh;">
        <p class="text-body-2 grey--text mb-4">
          Choose which widgets appear on your dashboard.
        </p>

        <!-- Category groups -->
        <div v-for="category in categories" :key="category" class="mb-4">
          <div class="text-overline grey--text mb-2">{{ category }}</div>
          <v-row dense>
            <v-col
              v-for="widget in widgetsByCategory(category)"
              :key="widget.id"
              cols="12"
              sm="6"
            >
              <v-card
                outlined
                class="widget-library-card pa-3"
                :class="{ 'widget-enabled': widget.enabled }"
                @click="toggle(widget.id)"
              >
                <div class="d-flex align-start">
                  <v-icon
                    :color="widget.enabled ? 'primary' : 'grey lighten-1'"
                    class="mr-3 mt-1"
                  >
                    {{ widget.icon }}
                  </v-icon>
                  <div class="flex-grow-1">
                    <div class="text-subtitle-2 font-weight-medium">
                      {{ widget.name }}
                    </div>
                    <div class="text-caption grey--text">
                      {{ widget.description }}
                    </div>
                  </div>
                  <v-switch
                    :input-value="widget.enabled"
                    dense
                    hide-details
                    class="mt-0 pt-0 ml-2"
                    @click.stop="toggle(widget.id)"
                  />
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text small color="error" @click="resetToDefaults">
          <v-icon small left>mdi-restore</v-icon>
          Reset to Defaults
        </v-btn>
        <v-spacer />
        <v-btn color="primary" text @click="close">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'WidgetLibrary',
  computed: {
    ...mapState('dashboard', ['libraryOpen']),
    ...mapGetters('dashboard', ['allWidgets']),
    dialogOpen: {
      get() { return this.libraryOpen; },
      set(val) { this.setLibraryOpen(val); },
    },
    categories() {
      const cats = [...new Set(this.allWidgets.map((w) => w.category))];
      return cats.sort();
    },
  },
  methods: {
    ...mapMutations('dashboard', [
      'setLibraryOpen',
      'toggleWidget',
      'resetToDefaults',
    ]),
    widgetsByCategory(category) {
      return this.allWidgets.filter((w) => w.category === category);
    },
    toggle(widgetId) {
      this.toggleWidget(widgetId);
    },
    close() {
      this.setLibraryOpen(false);
    },
  },
};
</script>

<style scoped>
.widget-library-card {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid var(--widget-lib-card-border, #e0e0e0);
}

.widget-library-card:hover {
  border-color: var(--widget-lib-card-active-border, #1976d2);
  background: var(--widget-lib-card-hover-bg, #f5f9ff);
}

.widget-enabled {
  border-color: var(--widget-lib-card-active-border, #1976d2);
  background: var(--widget-lib-card-active-bg, #e3f2fd);
}
</style>
